import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuOverviewQuerySchema, SearchScopeSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = MenuOverviewQuerySchema

const normalize = fieldNormalizer({
  enums: [{ field: 'search_scope', options: SearchScopeSchema.options }]
})

// Mirrors MenuOverviewRequest::prepareForValidation.
export const MenuOverview = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
